<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.advertiserName' | translate }}
  </label>
  <input type="text" class="form-control" id="companyName" formControlName="companyName" [ngClass]="{ 'is-invalid': campaignForm.get('companyName')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
